import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
// mui
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

const AnserFeedBack = ({ isFeedBackGood }) => {
  const [show, setShow] = useState(true);
  useEffect(() => {
    const timeId = setTimeout(() => {
      setShow(false);
    }, 10000);

    return () => clearTimeout(timeId);
  }, []);

  return (
    <Box>
      <Typography
        sx={{
          fontSize: "0.875rem",
          fontWeight: "700",
          color: "#121212",
          padding: "16px 0px",
          marginTop: "16px",
          marginBottom: "16px",
        }}
      >
        {/* eslint-disable-next-line no-nested-ternary */}
        {show
          ? isFeedBackGood
            ? " 感謝您的回饋建議，很高興分析結果對您有幫助！"
            : "很抱歉分析結果不如預期，我們將持續優化分析模型。"
          : ""}
      </Typography>
    </Box>
  );
};

export default AnserFeedBack;

AnserFeedBack.propTypes = {
  isFeedBackGood: PropTypes.bool,
};
AnserFeedBack.defaultProps = {
  isFeedBackGood: PropTypes.bool,
};
